import { FetchStatus } from '@powdr/constants';

import { WEATHER_PENDING, WEATHER_SUCCESS, WEATHER_ERROR } from '../types';

const initialState = {
  data: null,
  status: FetchStatus.IDLE,
  error: null,
};

const reducer = (weather) => {
  const property = process.env.GATSBY_PROPERTY_NAME;

  return {
    ...weather,
    property,
  };
};

export default (state = initialState, action) => {
  switch (action.type) {
    case WEATHER_PENDING:
      return {
        ...state,
        status: FetchStatus.LOADING,
      };
    case WEATHER_SUCCESS:
      return {
        ...state,
        data: reducer(action.payload),
        status: FetchStatus.SUCCESS,
      };
    case WEATHER_ERROR:
      return {
        status: FetchStatus.ERROR,
        error: action.payload,
      };
    default: return state;
  }
};
